export const placementChecker = (placement) => {
	return {
		suffixLeft: /-left$/.test(placement),
		suffixRight: /-right$/.test(placement),
		suffixTop: /-top$/.test(placement),
		suffixBottom: /-bottom$/.test(placement),
		isTop: /^top/.test(placement),
		isBottom: /^bottom/.test(placement),
		isLeft: /^left/.test(placement),
		isRight: /^right/.test(placement),
	};
};

export const is = {
    num: (a) => typeof a === 'number', 
    node: (a) => a && a.nodeType === Node.ELEMENT_NODE
}

export const validateType = (_data/*<generic*>*/, _types/*<array>*/, _error/*<string>*/) => {
    if(!(_types.includes(typeof(_data))
		 || (_types.includes('node') && is.node(_data))
		 || (_types.includes('array[number]') && _data.every(val => is.num(val)))))
      throw new Error(`${_error} must contain the following data types (${_types.map((each) => each.toUpperCase()).join(', ')})`)
}

export const styler = (_el, _style) => {
	Object.keys(_style).forEach((name) => (_el.style[name] = _style[name]));
};

export const getRect = (_el) => {
	return _el.getBoundingClientRect();
};

export const positioningEngine = (props, options) => {
	const { target, dialog, scrollView } = props;
	const d = document; 
	const { 
		scrollTop, 
		scrollLeft, 
		clientWidth: viewWidth, 
		clientHeight: viewHeight 
	} = scrollView;
	const {
		placement,
		offset: [offsetX = 10, offsetY = 10],
		useTranslatePositioning,
		arrowPointCenter,
		allowRootRelative,
		allowPersistent,
		rotateArrow,
	} = options;
	styler(dialog, {
		position: 'absolute',
	});
	const { offsetHeight: popHeight, offsetWidth: popWidth } = dialog;
	let targetTop, targetLeft, targetHeight, targetWidth;
	if (allowRootRelative) {
		const { top, left, height, width } = getRect(target);
		targetHeight = height;
		targetWidth = width;
		targetTop = scrollTop + top;
		targetLeft = scrollLeft + left;
	} else {
		const { offsetTop, offsetLeft, offsetHeight, offsetWidth } = target;
		targetHeight = offsetHeight;
		targetWidth = offsetWidth;
		targetTop = offsetTop
		targetLeft = offsetLeft
	}
	const targetTopDepth = targetTop + targetHeight;
	const targetLeftDepth = targetLeft + targetWidth;
	dialog.dataset.poppingPlacement = placement;
	let arrow = dialog.querySelector('[data-popping-arrow]');
	if (!arrow) {
		arrow = d.createElement('div');
		arrow.dataset.poppingArrow = true;
		dialog.appendChild(arrow);
	}
	let x, y;

	const {
		suffixLeft,
		suffixRight,
		suffixTop,
		suffixBottom,
		isTop,
		isBottom,
		isLeft,
		isRight,
	} = placementChecker(placement);

	if (isTop || isBottom) {
		x = targetLeft + (targetWidth - popWidth) / 2;
		y = isTop ? targetTop - popHeight - offsetY : targetTopDepth + offsetY;
		if (suffixRight) {
			x = targetLeft;
		}
		if (suffixLeft) {
			x = targetLeftDepth - popWidth;
		}
	}
	if (isLeft || isRight) {
		y = targetTop + (targetHeight - popHeight) / 2;
		x = isLeft ? targetLeft - popWidth - offsetX : targetLeftDepth + offsetX;
		if (suffixBottom) {
			y = targetTop;
		}
		if (suffixTop) {
			y = targetTopDepth - popHeight;
		}
	}

	y = allowPersistent
		? targetTopDepth < scrollTop
			? scrollTop + offsetY
			: targetTop > scrollTop + viewHeight
			? scrollTop + viewHeight - (offsetY + popHeight)
			: y
		: y;
	x = allowPersistent
		? targetLeftDepth < scrollLeft
			? scrollLeft + offsetX
			: targetLeft > scrollLeft + viewWidth
			? scrollLeft + viewWidth - (offsetX + popWidth)
			: x
		: x;
	let isDeadEnd = false;
	if (scrollLeft + viewWidth < x + popWidth || x < scrollLeft) {
		x = Math.max(0, (viewWidth - popWidth) / 2);
		isDeadEnd = true;
	}
	if (scrollTop + viewHeight < y + popHeight || y < scrollTop) {
		y = Math.max(0, (viewHeight - popHeight) / 2);
		isDeadEnd = true;
	}
	
	styler(dialog, {
		top: !useTranslatePositioning ? `${y}px` : 0,
		left: !useTranslatePositioning ? `${x}px` : 0,
		transform: useTranslatePositioning ? `translate(${x}px,${y}px)` : null,
	});
	const { offsetHeight: arrowHeight, offsetWidth: arrowWidth } = arrow;
	let xa, ya;
	const arrowHalfWidth = arrowWidth / 2;
	const arrowHalfHeight = arrowHeight / 2;
	if (isTop || isBottom) {
		ya = 0;
		xa = popWidth / 2 - arrowHalfWidth;
		if (suffixRight) {
			xa = arrowWidth;
		}
		if (suffixLeft) {
			xa = popWidth - arrowWidth * 2;
		}
		if (arrowPointCenter || isDeadEnd) {
			xa = targetLeft + targetWidth / 2 - x - arrowHalfWidth;
			xa =
				popWidth < xa
					? popWidth - (arrowWidth + arrowHalfWidth)
					: xa < 0
					? arrowHalfWidth
					: xa;
		}
	}
	if (isLeft || isRight) {
		xa = 0;
		ya = popHeight / 2 - arrowHalfHeight;
		if (suffixBottom) {
			ya = arrowHeight;
		}
		if (suffixTop) {
			ya = popHeight - arrowHeight * 2;
		}
		if (arrowPointCenter || isDeadEnd) {
			ya = targetTop + targetHeight / 2 - y - arrowHalfHeight;
			ya =
				popHeight < ya
					? popHeight - (arrowHeight + arrowHalfHeight)
					: ya < 0
					? arrowHalfHeight
					: ya;
		}
	}
	styler(arrow, {
		position: 'absolute',
		top: isLeft || isRight ? 0 : null,
		left: isTop || isBottom ? 0 : null,
		transform: `translate(${xa}px,${ya}px)${
			rotateArrow ? ` rotate(${rotateArrow}deg)` : ''
		}`,
	});
};